import React from "react";
import { ListItem, ListItemIcon, ListItemText, Box } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const MenuListItem = ({
  icon,
  name,
  logo,
  isHighlight,
  isHovered,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <ListItem
      button
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: isHighlight ? "#e9e9e9" : "transparent",
        border: isHighlight ? "1px solid #e5007e" : "none",
        borderRadius: isHighlight ? "4px" : "0px",
        padding: "8px 15px",
        marginBottom: isHighlight ? "8px" : "0px",
        color: isHighlight ? "#e5007e" : "#111",
        gap: "15px",
        "&:hover": {
          backgroundColor: isHighlight ? "#e5007e" : "#E1E1E1",
          color: isHighlight ? "#ffffff" : "#111",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
          flex: 1,
        }}
      >
        {/* Offer Arrow - για Category Menu */}
        {icon && (
          <ListItemIcon
            sx={{
              minWidth: "34px",
              color: "inherit",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              filter:
                isHighlight && isHovered ? "brightness(0) invert(1)" : "none",
              transition: "filter 0.3s ease",
            }}
          >
            <img
              src={icon}
              alt={name}
              style={{
                width: "24px",
                height: "24px",
                objectFit: "contain",
              }}
            />
          </ListItemIcon>
        )}
        <ListItemText
          primary={name}
          primaryTypographyProps={{
            sx: {
              fontWeight: 900,
              fontSize: "14px",
              fontFamily: "'Zen Maru Gothic', Arial, sans-serif",
              lineHeight: "1.2",
            },
          }}
        />
      </Box>

      {/* Arrow - για Category Menu */}
      {!logo && (
        <ArrowForwardIosIcon
          sx={{
            fontSize: "16px",
            color:
              isHighlight && isHovered
                ? "#ffffff"
                : isHighlight
                ? "#e5007e"
                : "#111",
            opacity: isHovered ? 1 : 0,
            transition: "opacity 0.6s ease, color 0.3s ease",
            flexShrink: 0,
          }}
        />
      )}

      {/* Logo - για Brand Menu */}
      {logo && (
        <Box
          sx={(theme) => ({
            display: "inline-flex",
            flexDirection: "column",
            alignItems: "center",
            px: "20px",
            py: "5px",
            borderRadius: "22px",
            flexShrink: 0,
            whiteSpace: "nowrap",
            justifyContent: "center",
            bgcolor: "#fff",
          })}
        >
          <img
            src={logo}
            alt={`${name} logo`}
            style={{
              width: "74px",
              height: "26px",
              objectFit: "contain",
            }}
          />
        </Box>
      )}
    </ListItem>
  );
};

export default MenuListItem;
